import React, { useState, useEffect } from 'react';
import { createIntl, createIntlCache, FormattedNumber } from 'react-intl';
import { getTemplateString } from 'common/helpers/string';
import MonthlyRate from './components/MonthlyRate/MonthlyRate';
import CurrentBalance from 'components/CurrentBalance/CurrentBalance';
import { useHistory } from 'react-router-dom';
import qs from 'qs';
import { useAppDispatch } from 'app/hooks';
import http from 'app/http';
import { setContent } from 'features/content/reducer';
import PageLink from 'components/PageLink/PageLink';
import styles from './ChooseYourPlanPageData.module.scss';
import StepIndicator from 'components/StepIndicator/StepIndicator';
import { selectCurrentMarket } from 'features/core/selectors';
import { Market } from 'common/consts/markets';
import { useAppSelector } from 'app/hooks';
import { FormatMoney } from 'common/helpers/numberHelper';
import classnames from 'classnames/bind';
import EditMonthlyIncomeandExpenditure from 'components/EditMonthlyIncomeandExpenditure/EditMonthlyIncomeandExpenditure';
import RepaymentList from 'components/RepaymentList/RepaymentList';
import { getGTMVariables, getGTMVariablesPageView } from 'common/helpers/Gtm';
import TagManager from 'react-gtm-module';

interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
}

const ChooseYourPlanPageData = (props: Props) => {
  const { Model, PageData, LayoutModel } = props;
  const dispatch = useAppDispatch();
  const discountRate = getTemplateString(PageData?.OfferDiscountLabel);
  const hasLimitClass = Model?.DisposableIncomeLimit ? 'has-limit' : '';
  const [instalmentValue, setinstalmentValue] = useState(
    Model?.SelectedInstalmentValue / 100,
  );
  const [numberofMonth, setnumberofMonth] = useState(Model?.InstalmentsNumber);
  const [isDisabled, setisDisabled] = useState(false);
  const [hideNextButton, setHideNextButton] = useState(false);
  const [showEditDisposablePopup, setShowEditDisposablePopup] = useState(false);
  const [eventTracked, setEventTracked] = useState<boolean>(false);
  const [finalPaymentValue, setFinalPaymentValue] = useState(
    Model?.FinalToBePaid,
  );
  const [availableIncome, setAvailableIncome] = useState<string>(
    Model?.DisposableFormModel?.DisposableIncome,
  );
  const [settlementPlanSetupEventTracked, setSettlementPlanSetupEventTracked] =
    useState<boolean>(false);
  const updateNumberofMonth = (value: any) => {
    setnumberofMonth(value);
  };
  const updateAmountslider = (value: any) => {
    setinstalmentValue(value);
  };
  const currentMarket = useAppSelector(selectCurrentMarket);
  let history = useHistory();

  const getPathnameFromUrl = (url: string) => {
    const link = new URL(url);

    return link.pathname + link.search;
  };
  const pathurl = getPathnameFromUrl(Model.DeterminePaymentAbilityUrl);

  const editDisposableOnClick = async (e: any) => {
    e.preventDefault();
    try {
      const response = await http.post(
        pathurl,
        // Convert object into string
        qs.stringify({
          selectedAmount: instalmentValue,
        }),
        {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
          },
        },
      );
      if (response && response.data) {
        // Get pathname from enpoint url, pathname will be used for redirect and as a key in content state
        var nextPagePath = '';
        if (!response.data.data) {
          nextPagePath = pathurl;
          dispatch(setContent({ [nextPagePath]: response.data }));
        } else {
          nextPagePath = getPathnameFromUrl(response.data.data);
          setShowEditDisposablePopup(true);
          //nextPagePath = getPathnameFromUrl(response.data.data);
        }

        // Add response to store
        //dispatch(setContent({ [nextPagePath]: response.data.RedirectUrl }));
        // Redirect to next step path
        // history.push(nextPagePath, {
        //   noRefresh: false,
        // });
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (eventTracked == false) {
      var tagManagerArgs: any;
      tagManagerArgs = {
        dataLayer: {
          event: 'checkout_step',
          checkout_name: 'Payment Plan Creation',
          checkout_step_number: '1',
          is_secured_user: LayoutModel?.IsLoggedInUserSecured,
          ...(LayoutModel?.IsLoggedInUserSecured && {
            secured_case_status: LayoutModel?.SecuredCaseStatus,
          }),
        },
      };
      TagManager.dataLayer(tagManagerArgs);
      setEventTracked(true);
    }
  }, [eventTracked]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    try {
      const response = await http.post(
        Model?.PostSelectedInstalmentUrl,
        // Convert object into string
        qs.stringify({
          'FormModel.Instalment': instalmentValue,
          'FormModel.payerReviewStatus': Model?.FormModel?.payerReviewStatus,
        }),
        {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
          },
        },
      );
      if (response && response.data) {
        // Get pathname from enpoint url, pathname will be used for redirect and as a key in content state
        var nextPagePath = '';
        if (!response.data.RedirectUrl) {
          nextPagePath = getPathnameFromUrl(Model?.PostSelectedInstalmentUrl);
          dispatch(setContent({ [nextPagePath]: response.data }));
        } else {
          nextPagePath = getPathnameFromUrl(response.data.RedirectUrl);
        }

        // Add response to store
        //dispatch(setContent({ [nextPagePath]: response.data.RedirectUrl }));
        // Redirect to next step path
        history.push(nextPagePath, {
          noRefresh: false,
        });
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    if (LayoutModel != undefined) {
      var userid =
        LayoutModel?.Profiles.length > 0
          ? LayoutModel?.Profiles[0].DebtReference
          : '';
      var isLoggedIn = LayoutModel?.HasProfile;
      var lang = PageData?.Language;
      var env = LayoutModel?.Environment;
      var reg = LayoutModel?.CountryCode;
      getGTMVariables(
        userid,
        isLoggedIn,
        lang,
        reg,
        env,
        LayoutModel?.IsLoggedInUserSecured,
        LayoutModel?.SecuredCaseStatus,
      );
      getGTMVariablesPageView(
        window.document.title,
        window.location.href,
        window.location.pathname,
        userid,
        isLoggedIn,
        lang,
        reg,
        env,
      );
    }
  }, [LayoutModel]);

  var tagManagerArgs: any;
  useEffect(() => {
    if (settlementPlanSetupEventTracked === false) {
      if (Model.ForOffer) {
        tagManagerArgs = {
          dataLayer: {
            event: 'checkout_step',
            checkout_name: 'Settlement Plan Setup',
            checkout_step_number: '1',
            is_secured_user: LayoutModel?.IsLoggedInUserSecured,
            ...(LayoutModel?.IsLoggedInUserSecured && {
              secured_case_status: LayoutModel?.SecuredCaseStatus,
            }),
          },
        };
        TagManager.dataLayer(tagManagerArgs);
        setSettlementPlanSetupEventTracked(true);
      }
    }
  }, [Model]);

  return (
    <div className={styles.wrapper_main}>
      <section className="CreateRepaymentPlan__section">
        <StepIndicator
          ActiveStep={Model?.ActiveWizardStep?.ActiveStep}
          TotalSteps={3}
          StepText={PageData?.StepText}
          OfText={PageData?.OfText}
        />
      </section>

      <div className={styles.wrapper}>
        <div className="Section--secondaryBg">
          <div className={styles.container}>
            <main className="CreateRepaymentPlan u-paddingTz">
              {(!Model.ForOffer || Model.IsInEditMode) && (
                <section className="CreateRepaymentPlan__section">
                  <h1 className="CreateRepaymentPlan__heading u-marginTz">
                    <>{PageData?.Header}</>
                  </h1>
                </section>
              )}
              {(Model.ForOffer || Model.IsInEditMode) && (
                <section className="CreateRepaymentPlan__section">
                  <h1 className="CreateRepaymentPlan__heading u-marginTz">
                    <>{PageData?.HeaderForOffer}</>
                  </h1>
                </section>
              )}

              <form id="ChooseYourPlanForm" onSubmit={handleSubmit}>
                {!Model.ForOffer ? (
                  <section className="CreateRepaymentPlan__section">
                    <div className="currentBalance">
                      <CurrentBalance
                        heading={PageData?.CurrentBalanceLabel}
                        currency={Model?.Currency}
                        balance={Model?.FormattedCurrencyDebtBalance}
                        balanceTooltip={PageData?.CurrentBalanceTooltip}
                        noPaymentPlan={
                          Model?.PageData?.CurrentBalanceTooltip != null ||
                          Model?.IsInEditMode
                        }
                        noPaymentPlanHeading={PageData?.CurrentBalanceTooltip}
                        noPaymentPlanTooltip={PageData?.CurrentBalanceTooltip}                        
                      />
                    </div>
                  </section>
                ) : (
                  <section className="CreateRepaymentPlan__section">
                    <div className="settlementAmount">
                      <div className="settlementAmount__wrapper">
                        <div className="settlementAmount__heading">
                          <span className="settlementAmount__label settlementAmount__label--large">
                            <>{PageData.OfferTotalAmountLabel}</>
                          </span>
                          <span className="settlementAmount__amount">
                            {Model?.FormattedCurrencyOfferDiscountedDebtBalance}
                          </span>
                        </div>
                        <div className="settlementAmount__row">
                          <div className="settlementAmount__column">
                            <span className="settlementAmount__label">
                              <>{PageData?.OfferCurrentBalanceLabel}</>
                            </span>
                            <span className="settlementAmount__balance">
                              {Model?.FormattedCurrencyOfferCurrentBalance}
                            </span>
                          </div>
                          <div className="settlementAmount__column">
                            <span className="settlementAmount__label">
                              {discountRate &&
                                discountRate({
                                  DiscountRate: Model?.DiscountRate,
                                })}
                            </span>
                            <span className="settlementAmount__discount">
                              {Model?.FormattedCurrencyOfferDiscountAmount}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}
                <section className="CreateRepaymentPlan__section">
                  <div className="CreateRepaymentPlan__calculation calculation">
                    <MonthlyRate
                      updateAmountslider={updateAmountslider}
                      instalmentValue={instalmentValue}
                      setinstalmentValue={setinstalmentValue}
                      numberofMonth={numberofMonth}
                      updateNumberofMonth={updateNumberofMonth}
                      handleError={setHideNextButton}
                      setisDisabled={setisDisabled}
                      setFinalPaymentValue={setFinalPaymentValue}
                      finalPaymentValue={finalPaymentValue}
                      availableIncome={availableIncome}
                      {...props}
                    />
                  </div>
                </section>
                {!(
                  currentMarket === Market.NL ||
                  currentMarket === Market.BE ||
                  currentMarket === Market.PL ||
                  (currentMarket === Market.DE && !Model.ForOffer)
                ) &&
                  Model.SliderShowMonths == true && (
                    <RepaymentList
                      Heading={PageData?.YourIndividualRepaymentPlan}
                      Monthlylabel={PageData?.MonthlyPaymentText}
                      Mothlyamount={instalmentValue}
                      Currencysymbol={Model?.FormattedCurrencySymbol}
                      IsCurrencyOnTheLeftSide={
                        LayoutModel?.IsCurrencyOnTheLeftSide
                      }
                      Decimalseparator={
                        LayoutModel?.DecimalSeparatorForNumberFormatter
                      }
                      Finallabel={PageData?.FinalPaymentLabel}
                      FinalAmount={
                        finalPaymentValue > 0 ? finalPaymentValue / 100 : 0
                      }
                      Totaltext={PageData?.DebtBalance}
                      Totalamount={Model?.FormattedCurrencyDebtBalance}
                      DisposableIncomeLimit={Model?.DisposableIncomeLimit}
                      NumberofMonth={numberofMonth}
                      BalanceLabel={PageData?.PaymentPlanItemDebtBalanceLabel}
                      BalanceAmount={
                        Model?.FormattedCurrencyOfferCurrentBalance
                      }
                      DiscountBalancelabel={
                        PageData?.PaymentPlanItemDiscountAmountLabel
                      }
                      DiscountBalanceAmount={
                        Model?.FormattedCurrencyOfferDiscountAmount
                      }
                      DiscountedDebtBalanceRaw={Model?.Offer?.DiscountAmount}
                    />
                  )}
                {!Model.IsBankingCustomer &&
                Model?.DisposableIncomeLimit >= 0 ? (
                  <section className="CreateRepaymentPlan__section">
                    <div className="Grid Grid--gutterH Grid--white GridWhite--smFull u-marginBxsm">
                      <div className="Grid-cell">
                        <div className="Editdisposibleincome Editdisposibleincome-block">
                          <div className="monthlyIncome">
                            <p className="monthlyIncome__text">
                              <>{PageData?.YourDisposibleMonthlyIncome}</>
                            </p>
                            {Model.DisposableIncomeLimit !== null &&
                              Model.DisposableIncomeLimit >= 0 && (
                                <p className="monthlyIncome__value">
                                  <span>
                                    {
                                      Model?.FormattedCurrencyDisposableIncomeLimit
                                    }
                                  </span>
                                </p>
                              )}
                            <button
                              type="button"
                              className="Button Button--ghost Button--small w-100"
                              onClick={editDisposableOnClick}
                            >
                              <span>
                                {PageData?.EditDeterminePaymentAbility}
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                ) : (
                  <section className="CreateRepaymentPlan__section">
                    {!(Model.DisposableIncomeLimit != null) && (
                      <>
                        <div className="Grid Grid--gutterH Grid--white GridWhite--smFull">
                          <div className="Grid-cell">
                            <div className="Editdisposibleincome Editdisposibleincome-block">
                              <p className="CreateRepaymentPlan__plainText CreateRepaymentPlan__plainText--no-margin">
                                <>{PageData?.CantAffordThePaymentsQuestion}</>
                              </p>
                              <button
                                type="button"
                                className="Button Button--ghost Button--small button_bottommargin"
                                onClick={editDisposableOnClick}
                              >
                                <span>{PageData?.DeterminePaymentAbility}</span>
                              </button>
                              <p className="CreateRepaymentPlan__plainText">
                                <>{PageData?.ContinueMessage}</>
                              </p>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </section>
                )}
                <section className="CreateRepaymentPlan__section">
                  <div className="CreateRepaymentPlan__ctaWrapper button-alignment">
                    <PageLink
                      url={Model.BackButtonUrl}
                      text={PageData.BackButtonLabel}
                      className="Button Button--gray CreateRepaymentPlan__cancelBtn"
                    />
                    <button
                      type="submit"
                      id="choose-your-plan-submit"
                      className={
                        'Button CreateRepaymentPlan__confirmBtn action continue-button ' +
                        (isDisabled ? styles.disabled : '')
                      }
                    >
                      <>{PageData?.ContinueButtonLabel}</>
                    </button>
                  </div>
                </section>
              </form>
            </main>
          </div>
          <div
            className={classnames(
              showEditDisposablePopup
                ? 'modal-overlay is-active'
                : 'modal-overlay',
            )}
          >
            <div className="modal-dialog">
              <EditMonthlyIncomeandExpenditure
                closePop={setShowEditDisposablePopup}
                Model={Model}
                PageData={PageData}
                instalmentValue={instalmentValue}
                layoutModel={LayoutModel}
                setAvailableIncome={setAvailableIncome}
                availableIncome={availableIncome}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseYourPlanPageData;
